import React from "react";
import PaystackCheckout from "./Paystack";
import StripeCheckout from "./Stripe";
import { useUserLocation } from "../../../../../../hooks/useUserLocation";
import PageTitle from "../../../../../layouts/PageTitle";

export const CheckoutPage = () => {
  const { paymentGateway, loading, error } = useUserLocation();

  // Example data
  const amount = 50;
  const email = "user@example.com";

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 p-4 flex items-center justify-center">
        <div className="bg-white rounded shadow-sm w-full max-w-md p-4">
          <div className="flex items-center justify-center space-x-2 py-8">
            <div className="w-4 h-4 border-2 border-indigo-600 rounded-full border-t-transparent animate-spin"></div>
            <p className="text-sm text-gray-600">Loading payment options...</p>
          </div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen bg-gray-50 p-4 flex items-center justify-center">
        <div className="bg-white rounded shadow-sm w-full max-w-md p-4">
          <div className="py-8 text-center">
            <p className="text-sm text-red-500 mb-4">{error}</p>
            <button
              onClick={() => window.location.reload()}
              className="px-4 py-2 text-sm bg-indigo-600 text-white rounded hover:bg-indigo-700 transition"
            >
              Try Again
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50 p-4">
      <PageTitle activeMenu="Checkout" motherMenu="Schedule Session" />

      <div className="row">
        <div className="col-xl-12">
          <div className="card">
            <div className="card-body">
              <div className="row">
                <div className="col-md-8 order-md-1">
                  <h4 className="mb-3">Payment</h4>
                  <div className="bg-white rounded overflow-hidden">
                    <div className="h-12 bg-indigo-600 relative">
                      <div className="absolute -bottom-12 w-full h-24 bg-indigo-600 rounded-b-full"></div>
                    </div>
                    <div className="relative px-6 pt-16 pb-6">
                      {paymentGateway === "paystack" ? (
                        <PaystackCheckout amount={amount} email={email} />
                      ) : (
                        <StripeCheckout amount={amount} />
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};